import { createStructuredSelector } from 'reselect';

export const getConversations = (state) => state.conversations;

export const conversationsSelector = createStructuredSelector({
    conversations: getConversations,
});